import { render, staticRenderFns } from "./LiefengContent2.vue?vue&type=template&id=70865b89&scoped=true&"
import script from "./LiefengContent2.vue?vue&type=script&lang=js&"
export * from "./LiefengContent2.vue?vue&type=script&lang=js&"
import style0 from "./LiefengContent2.vue?vue&type=style&index=0&id=70865b89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70865b89",
  null
  
)

export default component.exports